import React, { useState, useContext, useEffect } from "react";
import CustomModal from "../common/Modal";
import { AppStateContext } from "../../state/AppProvider";
import { logoutApi } from "../../api";
import { useNavigate } from "react-router-dom";
import { userUpdateAcceptanceStatus } from "../../api";

interface TermsOfUseProps {
    headerText: string;
    buttonLabel?: string;
}

export const TermsOfUseModal: React.FC<TermsOfUseProps> = ({ headerText, buttonLabel }) => {
    const appStateContext = useContext(AppStateContext);
    const [isModalOpen, setIsModalOpen] = buttonLabel
        ? useState<boolean>(!appStateContext?.state.acceptedTermsOfUse)
        : useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(true);

    const modal_id = "terms-of-use-modal";
    const navigate = useNavigate();

    const saveToDB = async (acceptance_status: boolean) => {
        return await userUpdateAcceptanceStatus(acceptance_status);
    };

    const handleTermsOfUseModalAccept = async () => {
        if (!appStateContext?.state.acceptedTermsOfUse) {
            appStateContext?.dispatch({ type: "UPDATE_ACCEPTED_TERMS_OF_USE", payload: true });
            const response = await saveToDB(true);
            if (response.status === 500) {
                console.log("Error saving global settings");
                return;
            }
        }

        const modal = document.getElementById(modal_id) as HTMLDialogElement;
        if (modal) modal.close();
    };

    const handleTermsOfUseModalClose = async () => {
        const modal = document.getElementById(modal_id) as HTMLDialogElement;

        if (appStateContext?.state.acceptedTermsOfUse) {
            if (modal) modal.close();
        } else if (showButton && !appStateContext?.state.acceptedTermsOfUse) {
            await logoutApi();
            navigate("/acceptance_failed");
        } else {
            if (modal) modal.close();
        }
    };

    useEffect(() => {
        if (appStateContext?.state.acceptedTermsOfUse) {
            setIsModalOpen(false);
            setShowButton(false);
        } else if (buttonLabel) {
            setIsModalOpen(true);
            setShowButton(true);
        } else {
            setIsModalOpen(false);
            setShowButton(false);
        }
    }, [appStateContext?.state.acceptedTermsOfUse]);

    return (
        <div>
            <button
                className=" pr-4 btn btn-link !text-navbar-item !font-navbar-item !text-darkpink !no-underline hover:!underline"
                onClick={() => {
                    setIsModalOpen(true);
                }}
            >
                Nutzungsbedingungen
            </button>
            <CustomModal
                headerText={headerText}
                buttonLabel={buttonLabel}
                onConfirm={buttonLabel ? handleTermsOfUseModalAccept : undefined}
                onCancel={showButton ? undefined : handleTermsOfUseModalClose}
                modal_id={modal_id}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                showAcceptButton={buttonLabel ? showButton : false}
            >
                <div className="">
                    <h4 className="label font-modal-item text-modal-item pt-1">Stand: 13. März 2024</h4>
                    <p className="py-2 font-chat-text !font-size-6">
                        Hinweis: hier wird das generische Maskulinum verwendet, wobei dabei ausdrücklich alle
                        Geschlechter mitgemeint sind. Diese Vorgehensweise hat lediglich redaktionelle Gründe und
                        beinhaltet keinerlei Wertung.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">1. Geltungsbereich</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Diese Nutzungsbedingungen gelten für alle Mitarbeiter und Kunden (insbesondere Studenten,
                        Schülern etc.) sowie externe Lehrbeauftragte der Carl Remigius Fresenius Education AG und der
                        mit ihr nach § 15 AktG verbunden Unternehmen, die die Webseite und die Dienste des Chatbot
                        NextGeneration:AI in Erfüllung des Arbeitsverhältnisses bzw. Auftrages sowie auf Grund des
                        Kundenvertrages (insbesondere Studium, Ausbildungsvertrag etc.) verwenden. Eine Nutzung durch
                        minderjährige Personen ist untersagt.
                        <br />
                        Die Webseite und die Dienste des Chatbot NextGeneration:AI stehen unentgeltlich zur Verfügung.
                        Allerdings besteht für jeden Nutzer ein zugewiesenes monatliches Kontingent an „Credits“, die
                        durch die Nutzung verbraucht werden. Wenn das monatliche Kontingent an Credits aufgebraucht ist,
                        können in dem Monat auch keine Chats mehr geführt werden. Der Nutzer kann dies stets einsehen
                        unter dem Feld „Mein Gebrauch“.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">
                        2. Nutzungsberechtigung und Einschränkungen
                    </h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Jeder Nutzer erhält eine persönliche, nicht exklusive und nicht übertragbare Lizenz zur Nutzung
                        dieser Website zu Informationszwecken und zur Nutzung der Chat-Dienste über den Chatbot
                        NextGeneration:AI. Die Nutzung der Website und des Chatbot ist ausschließlich in Erfüllung des
                        Arbeitsverhältnisses bzw. Auftrages sowie auf Grund des Kundenvertrages (insbesondere Studium,
                        Ausbildungsvertrag etc.) gestattet.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Die Nutzung der Webseite und der Chat-Dienste über den Chatbot NextGeneration:AI erfordert eine
                        Systemanmeldung des jeweiligen Nutzers. Die Anmeldung für den Chatbot erfolgt über einen Link
                        aus der Lernplattform Ilias heraus. Beim Anklicken dieses Links werden die Benutzerdaten aus
                        Ilias direkt an die Website weitergeleitet und die Nutzer automatisch im Hintergrund eingeloggt.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Der Nutzer ist berechtigt, die von ihm mit NextGeneration:AI erstellten Ausgaben zu verwenden,
                        einschließlich der Berechtigung, diese nachzudrucken, zu verkaufen und zu vermarkten. Wir weisen
                        den Nutzer darauf hin, dass die vom Chatbot erstellten Ergebnisse regelmäßig nicht rechtlich
                        schutzfähig sind. Soweit eine Schutzfähigkeit besteht, behält der Nutzer die Urheberrechte an
                        seinen Eingaben (auch genannt „Prompts“), soweit wir zur Einräumung dieser Rechte befugt sind.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Der Nutzer wird die Website nicht für illegale oder unzulässige Zwecke nutzen und sich an alle
                        geltenden Gesetze und Vorschriften halten. Die Website sowie die Chat-Dienste über den Chatbot
                        NextGeneration:AI dürfen nicht für den Vertrieb von Spam, rechtswidrigen Inhalten oder
                        unerwünschter Werbung genutzt werden. Der Nutzer ist alleine datenschutzrechtlich und
                        urheberrechtlich verantwortlich für von ihm eingegebene Inhalte (auch genannt „Prompts“).
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Es ist dem Nutzer untersagt, die Website und den Chatbot in einer Weise zu nutzen, die die
                        Integrität, Sicherheit oder Verfügbarkeit der Website, des Chatbots oder ihrer jeweiligen
                        Funktionen beeinträchtigen oder beeinträchtigen könnten. Dies umfasst insbesondere, aber nicht
                        nur, das Umgehen von Sicherheitsmaßnahmen, das Erheben von personenbezogenen Daten anderer
                        Benutzer oder das Versenden von rechtswidrigen Inhalten.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">Insbesondere ist verboten:</p>
                    <ul className="list-disc ml-6 py-2 font-chat-text text-chat-text">
                        <li>
                            Zu versuchen, den Quellcode oder die zugrunde liegenden Komponenten unserer Dienste,
                            einschließlich unserer Modelle, Algorithmen oder Systeme, zurückzuentwickeln, zu
                            dekompilieren oder zu entdecken, oder die Beihilfe hierzu, soweit dies nicht
                            urheberrechtlich zwingend erlaubt ist.
                        </li>
                        <li>
                            Beeinträchtigung oder Unterbrechung der Dienste oder der Umgehung von Schutzmaßnahmen oder
                            Sicherheitsmaßnahmen.
                        </li>
                        <li>Modifikation, Verkauf oder Vertrieb der Dienste.</li>
                        <li>Nutzung der Dienste zur Erstellung von Wettbewerbsprodukten.</li>
                    </ul>
                    <p className="py-2 font-chat-text text-chat-text">
                        Verstöße gegen diese Bestimmungen können straf- und zivilrechtlich verfolgt werden sowie zur
                        sofortigen Beendigung der Nutzungsberechtigung führen. Die Nutzer sind verpflichtet, nach bestem
                        Wissen und Gewissen Handlungen und Dateneinträge in dem Chatbot NextGeneration:AI zu
                        unterlassen, die zu einer Störung des Gesamtbetriebes führen könnten.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">3. Genauigkeit</h3>
                    <p className="py-2 font-chat-text text-chat-text">Der Nutzer stimmt Folgendem zu:</p>
                    <ul className="list-disc ml-6 py-2 font-chat-text text-chat-text">
                        <li>
                            Die Ausgabe ist möglicherweise nicht immer korrekt. Der Nutzer kann sich nicht auf die
                            Ergebnisse der Dienste des NextGeneration:AI als alleinige Quelle wahrer oder sachlicher
                            Informationen oder als Ersatz für professionelle Beratung verlassen.
                        </li>
                        <li>
                            Der Nutzer muss die Ausgabe auf Richtigkeit und Eignung für den Anwendungsfall prüfen,
                            gegebenenfalls auch durch menschliche Überprüfung, bevor er die Ausgabe der Dienste nutzt
                            oder weitergibt.
                        </li>
                        <li>
                            Der Nutzer kann keine auf eine Person bezogenen Ergebnisse für Zwecke verwenden, die
                            rechtliche oder materielle Auswirkungen auf diese Person haben könnten, wie z. B. Kredit-,
                            Bildungs-, Beschäftigungs-, Wohnungs-, Versicherungs-, rechtliche, medizinische oder andere
                            wichtige Entscheidungen über sie.
                        </li>
                        <li>
                            Die Dienste des NextGeneration:AI liefern möglicherweise unvollständige, falsche oder
                            anstößige Ausgaben, die nicht die Ansichten von Carl Remigius Fresenius Education AG und der
                            mit ihr nach § 18 AktG verbundenen Unternehmen widerspiegeln. Wenn Output auf Produkte oder
                            Dienstleistungen Dritter verweist, bedeutet das nicht, dass der Dritte Carl Remigius
                            Fresenius Education GmbH oder ein mit diesem nach § 18 AktG verbundenes Unternehmen
                            unterstützt oder mit Carl Remigius Fresenius Education GmbH ein mit diesem nach § 18 AktG
                            verbundenes Unternehmen verbunden ist.
                        </li>
                    </ul>
                    <h3 className="label font-modal-item text-modal-item pt-4">4. Geistiges Eigentum</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Die Inhalte auf dieser Website, einschließlich Texte, Grafiken, Logos, Designs, Software und
                        Audio-/Videomaterialien, unterliegen dem Urheberrecht und anderen geistigen Eigentumsrechten.
                        Diese Inhalte dürfen nicht ohne ausdrückliche Zustimmung der Carl Remigius Fresenius Education
                        GmbH kopiert, reproduziert, verteilt oder anderweitig verwendet werden.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Alle Marken, Logos und Markennamen, die auf dieser Website erscheinen, sind Eigentum ihrer
                        jeweiligen Inhaber. Es ist nicht gestattet, diese Marken ohne vorherige schriftliche Genehmigung
                        des jeweiligen Inhabers zu verwenden
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Der Nutzer ist ausschließlich befugt, Eingaben und Outputs entsprechend der in dieser
                        Vereinbarung eingeräumten Rechte zu nutzen.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">5. Haftungsbeschränkung</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Carl Remigius Fresenius Education GmbH übernimmt keine Gewähr für die Richtigkeit,
                        Vollständigkeit oder Zuverlässigkeit der Informationen auf dieser Website. Die Nutzung der
                        Website erfolgt auf eigene Gefahr. Carl Remigius Fresenius Education GmbH übernimmt keine
                        Verantwortung für Schäden, die durch die Nutzung der Website entstehen. Dies umfasst vor allem
                        auch Schäden, die durch Unterbrechungen, technische Probleme, Datenverlust oder den Zugriff auf
                        externe Websites entstehen.
                    </p>
                    <p className="py-2 font-chat-text text-chat-text">
                        Darüber hinaus haftet Carl Remigius Fresenius Education GmbH bei Vorsatz und grober
                        Fahrlässigkeit nach den gesetzlichen Bestimmungen. Bei einfacher Fahrlässigkeit haftet Carl
                        Remigius Fresenius Education GmbH nur für Schäden aus der Verletzung des Lebens, des Körpers
                        oder der Gesundheit und bei der Verletzung einer vertragswesentlichen Pflicht, deren Erfüllung
                        die ordnungsgemäße Vertragsdurchführung überhaupt erst ermöglicht nur in Höhe des vorhersehbaren
                        typischerweise eintretenden Schadens. Im Übrigen ist die Haftung der Carl Remigius Fresenius
                        Education GmbH ausgeschlossen.{" "}
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">
                        6. Laufzeit, Kündigung, Löschung und Sperre
                    </h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Dieser Nutzungsvertrag läuft auf unbestimmte Zeit und kann mit einer Frist von einer Woche
                        ordentlich gekündigt werden. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund
                        bleibt unberührt. Bei erheblichen Verstößen gegen diese Nutzungsbedingungen kann Carl Remigius
                        Fresenius Education GmbH die Nutzung von NextGeneration:AI für den betreffenden Nutzer sofort
                        und auch ohne Vorankündigung sperren. Nichts in dieser Vereinbarung verpflichtet Carl Remigius
                        Fresenius Education GmbH, die Nutzung von NextGeneration:AI dauerhaft oder auch nur bis zum
                        Verbrauch der jeweiligen Credits zu ermöglichen.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">7. Änderungen der Bedingungen</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Carl Remigius Fresenius Education GmbH behält sich das Recht vor, diese Bedingungen jederzeit zu
                        ändern oder zu aktualisieren. Die aktualisierten Bedingungen werden auf der Website
                        veröffentlicht, und es liegt in der Verantwortung des Nutzers, regelmäßig darauf zuzugreifen und
                        etwaige Änderungen zur Kenntnis zu nehmen.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">8. Datenschutz</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Die Nutzung der Website unterliegt der Datenschutzrichtlinie der Carl Remigius Fresenius
                        Education GmbH, die regelt, wie personenbezogene Informationen erfasst, verwendet und
                        offengelegt werden. Diese Richtlinien können hierunter abgerufen werden. Die
                        datenschutzrechtliche Verantwortlichkeit für die Eingaben in NextGeneration:AI liegen bei dem
                        Nutzer.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">9. Salvatorische Klausel</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Sollte eine Bestimmung dieser Bedingungen für ungültig oder undurchsetzbar erklärt werden,
                        bleiben die übrigen Bestimmungen weiterhin in vollem Umfang wirksam.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">
                        10. Anwendbares Recht und Gerichtsstand
                    </h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Diese Bedingungen unterliegen den Gesetzen von Deutschland. Jegliche Streitigkeiten im
                        Zusammenhang mit diesen Bedingungen unterliegen der ausschließlichen Zuständigkeit der deutschen
                        Gerichte.
                    </p>
                    <h3 className="label font-modal-item text-modal-item pt-4">11. Kontakt</h3>
                    <p className="py-2 font-chat-text text-chat-text">
                        Wenn Fragen oder Bedenken bezüglich dieser Nutzungsbedingungen bestehen, kann eine E-Mail an{" "}
                        <a href="mailto:ki@crf-education.com?subject=Nutzungsbedingungen" className="underline">
                            ki@crf-education.com
                        </a>{" "}
                        gesendet werden.
                    </p>
                    {showButton && (
                        <>
                            <div>
                                <h3 className="label font-modal-item text-modal-item pt-4">Einverständniserklärung</h3>
                                <p className="py-2 font-chat-text text-chat-text">
                                    Mit dem Klick auf "Akzeptieren" wird bestätigt, dass die Nutzungsbedingungen gelesen
                                    und akzeptiert wurden.{" "}
                                </p>
                            </div>
                        </>
                    )}
                </div>
            </CustomModal>
        </div>
    );
};

export default TermsOfUseModal;
